import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import React from 'react';
import { classNames } from '../_common/defaultImports';
import { ChevronDownIconOutline, ChevronUpIconOutline } from '../icons';
/**
 *
 *
 * DropdownButton Component
 *
 *
 */
export const DropdownButton = React.forwardRef(function DropdownButton({ as, children, size = 'medium', isDisabled, isFloating = false, leftIcon, isOpen = false, onClick, className, style, htmlAttributes, }, ref) {
    const classes = classNames('ndl-dropdown-btn', className, {
        'ndl-small': size === 'small',
        'ndl-medium': size === 'medium',
        'ndl-large': size === 'large',
        'ndl-disabled': isDisabled,
        'ndl-floating-btn': isFloating,
        'ndl-open': isOpen,
    });
    const Component = as || 'button';
    return (_jsxs(Component, Object.assign({ className: classes, disabled: isDisabled, onClick: onClick, ref: ref, style: style }, htmlAttributes, { children: [_jsxs("div", { className: "ndl-dropdown-btn-left-wrapper", children: [leftIcon && leftIcon, children] }), isOpen ? (_jsx(ChevronUpIconOutline, { className: "n-size-token-6 ndl-dropdown-button-open-icon" })) : (_jsx(ChevronDownIconOutline, { className: "n-size-token-6 ndl-dropdown-button-closed-icon" }))] })));
});
//# sourceMappingURL=DropdownButton.js.map